import { UserRole } from "@assoanalytics/app/core/models/user/user-role";
import { NavItems } from "./nav-item/nav-item";
import { sidebarElements } from "./sidebar-elements";

export const navItems: NavItems = {
  [UserRole.User]: [],
  [UserRole.Plant]: [
    sidebarElements.dashboard,
    sidebarElements.clients,
    sidebarElements.plants,
    sidebarElements.ossPrezzi,
  ],
  [UserRole.Net]: [
    sidebarElements.dashboard,
    sidebarElements.clients,
    sidebarElements.bi,
    sidebarElements.plants,
    // sidebarElements.netPro,
    sidebarElements.ossPrezzi,
    sidebarElements.externalLinks,
    sidebarElements.assoPayments,
    sidebarElements.assoStations,
  ],
};
